
import BaseBlock from '@headlines/utils/BaseBlock';
import BlockTypeSettings from '@headlines/types/block/21-30/blockType26';
import AdFormBanner from '@ads/components/adForm/AdFormBanner.vue';

const defaultSettings = {
  component: 'adFormBanner',
  adType: 'mobile',
  data: {},
};

export default BaseBlock<BlockTypeSettings>(defaultSettings).extend({
  components: {
    AdFormBanner,
  },
  props: {
    settings: {
      type: Object,
      required: true,
    },
  },
});
